import * as React from 'react';

import MetricsChannelsBasic from './MetricsChannelsBasic';

import type { ChannelTypes, Channels } from 'types';
import type { MetricsChannelsBasicItem } from 'components/metrics/channels-basic/types';


type Props = Omit<React.ComponentProps<typeof MetricsChannelsBasic>, 'channels'> & {
  channels: Channels
};

const MetricsChannelsBasicChannelsHOC: React.FC<Props> = (props: Props) => {
  const { channels, ...rest } = props;

  const mappedChannels: Array<MetricsChannelsBasicItem> = [];
  const showChannels: Array<ChannelTypes> = rest.showChannels ?? [];

  showChannels.forEach((channel) => {
    const channelInfo = channels[channel];
    if (channelInfo) {
      mappedChannels.push({
        engagementRate: channelInfo.metrics?.engagement,
        followers: channelInfo.metrics?.followers,
        type: channel,
        url: channelInfo.url
      });
    }
  });

  return (
    <MetricsChannelsBasic
      {...rest}
      channels={mappedChannels}
    />
  );
};

export default MetricsChannelsBasicChannelsHOC;
